import React from "react";
import { createRoot } from 'react-dom/client';
import ErrorBox from "../../common/ErrorBox";
import { useState, useEffect } from "react";
import { ConfigProvider, Modal, App, Tabs, Spin } from 'antd';
import { EditableContextProvider } from "../../common/EditableContextProvider";
import { customTheme } from "../../common/customTheme";
import { useCasos } from "./useCasos";
import { TableComponent } from "./TableComponent";
import { FormComponent } from "./FormComponent";
import { TablePasos } from "./TablePasos";
import { TablePagos } from "./TablePagos";
import { DocumentosModal } from "./DocumentosModal";
import { Formik, Form } from "formik";

export default function Main() {
    const context = useCasos();

    useEffect(() => {
        Promise.all([context.casos.fillResources(), context.casos.fillItems()]);
    }, []);

    return (
        <div>
            <EditableContextProvider data={{
                ...context
            }}
            >
                <div className='d-flex justify-content-between my-1 py-1'>
                    <button className="btn btn-sm border agregarBgColor"
                        onClick={() => { context.casos.newItem(); }}
                    >
                        <i className="fa-solid fa-plus me-1"></i>
                        Agregar
                    </button>

                    <button className="btn btn-sm border agregarBgColor"
                        onClick={() => { context.fileModalParams.showModalFile(); }}
                    >
                        <i className="fa-solid fa-table me-1"></i>
                        Actualizar presupuesto de casos (Excel)
                    </button>
                </div>
                <TableComponent />

                <Modal
                    width={900}
                    open={context.casos.visibleForm}
                    onCancel={context.casos.closeForm}
                    destroyOnClose={true}
                    footer={null}
                    style={{ top: '20px' }}
                >
                    <Tabs
                        items={[
                            { key: "1", label: "Formulario", children: (<FormComponent />) },
                            { key: "2", label: "Pasos", children: (<TablePasos />) }
                        ]}
                    />
                </Modal>

                <Modal
                    width={1200}
                    open={context.pagos.visibleModalPagos}
                    onCancel={context.pagos.closeModalPagos}
                    destroyOnClose={true}
                    footer={null}
                >
                    <TablePagos />
                </Modal>

                <Modal title="Formulario"
                    open={context.fileModalParams.modalFileVisibility}
                    onCancel={context.fileModalParams.hideModalFile}
                    destroyOnClose={true}
                    footer={null}
                >
                    <Formik
                        initialValues={{ massive_file: null }}
                        onSubmit={context.fileModalParams.submitUploadFile}
                        enableReinitialize={true}
                    >
                        {
                            (formik) => (
                                <Form action="">
                                    <div className="mb-2">
                                        <label className="form-label" htmlFor="massive_file">
                                            Archivo:
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input type="file" className="form-control form-control-sm" name="massive_file" id="massive_file"
                                            onChange={(e) => context.fileModalParams.setFileParam(e.target.files[0])}
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            required />
                                    </div>
                                    <div className="mb-2 d-flex justify-content-between">
                                        <div>
                                            <span className="text-danger">(*) </span>
                                            <u>Campo obligatorio.</u>
                                        </div>
                                        <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                            {
                                                (context.fileModalParams.fileLoading) ? (
                                                    <Spin size="small" />
                                                ) : "Guardar"
                                            }
                                        </button>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </Modal>

                <DocumentosModal />

            </EditableContextProvider>
        </div>
    );
}

let main = document.getElementById('casos-main');
if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App>
                        <Main />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
